/* globals
    STANDARD_AICC,
    STANDARD_CMI5,
    STANDARD_SCORM_12,
    STANDARD_SCORM_2004_2ND_EDITION,
    STANDARD_SCORM_2004_3RD_EDITION,
    STANDARD_SCORM_2004_4TH_EDITION,
    STANDARD_TINCAN,
    STANDARD_LTI11,
    STANDARD_LTI13
*/
function LearningStandard (LearningStandardValue) {
    this.value = LearningStandardValue;
}

LearningStandard.prototype = {
    isAICC: function () {
        if (this.value === STANDARD_AICC) {
            return true;
        }

        return false;
    },

    isCmi5: function () {
        if (this.value === STANDARD_CMI5) {
            return true;
        }

        return false;
    },

    isLti: function () {
        if (this.value === STANDARD_LTI11 || this.value === STANDARD_LTI13) {
            return true;
        }

        return false;
    },

    isLti11: function () {
        if (this.value === STANDARD_LTI11) {
            return true;
        }

        return false;
    },

    isLti13: function () {
        if (this.value === STANDARD_LTI13) {
            return true;
        }

        return false;
    },

    is12: function () {
        if (this.value === STANDARD_SCORM_12) {
            return true;
        }

        return false;
    },

    is2004: function () {
        if (this.value === STANDARD_SCORM_2004_2ND_EDITION
            || this.value === STANDARD_SCORM_2004_3RD_EDITION
            || this.value === STANDARD_SCORM_2004_4TH_EDITION
        ) {
            return true;
        }

        return false;
    },

    is20043rdOrGreater: function () {
        if (this.value === STANDARD_SCORM_2004_3RD_EDITION
            || this.value === STANDARD_SCORM_2004_4TH_EDITION
        ) {
            return true;
        }

        return false;
    },

    is20044thOrGreater: function () {
        if (this.value === STANDARD_SCORM_2004_4TH_EDITION) {
            return true;
        }

        return false;
    },

    isTinCan: function () {
        if (this.value === STANDARD_TINCAN) {
            return true;
        }

        return false;
    },

    toString: function () {
        return this.value;
    }
};
